<template>
  <iframe
		:src="`${url}&brand=0`"
		allowfullscreen
		sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
		allow="vr">
	</iframe>
</template>

<script>
	export default {
		props: {
      url: {
        default: '',
        type: String
      }
    }
	}
</script>
